import Validator, { IValidator } from "./Validator";

export interface IPhoneNumberValidator extends IValidator {}

const validatePhoneNumber = (value: string) => {
  const re = /^\+?[0-9. ()-]{5,25}$/;
  return re.test(String(value).toLowerCase());
};

const PhoneNumberValidator = (
  field: string,
  message?: string | undefined
): IPhoneNumberValidator => {
  const _message = message ?? "invalid_phone_number";

  return Object.assign(Validator(field, _message), {
    isValid: async (obj: any, value: any) => {
      return Promise.resolve(validatePhoneNumber(value));
    }
  }) as IPhoneNumberValidator;
};

export default PhoneNumberValidator;
